<i class="pi pi-question-circle" (click)="onOpenModal()" *ngIf="show"></i>

<help-modal *ngIf="openModal"
	[title]="title"
    [display]="openModal"
    [dataModal]="infoModal"
	(hideModal)="closeModal($event)">
</help-modal>